module.exports = "/_next/static/images/29940dcdcb4d36eef41ed00e6c00d451-icon-3.svg";